// extracted by mini-css-extract-plugin
export default {"teamMembersDropdown":"style_teamMembersDropdown__C4pUz"};